import { render } from "./FamilyQuickCreateModal.vue?vue&type=template&id=77abdf10&scoped=true"
import script from "./FamilyQuickCreateModal.vue?vue&type=script&lang=js"
export * from "./FamilyQuickCreateModal.vue?vue&type=script&lang=js"

import "./FamilyQuickCreateModal.vue?vue&type=style&index=0&id=77abdf10&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77abdf10"]])

export default __exports__